import React, { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import { queryParamsToObject } from "../DataTableUtils";
import moment from "moment";

interface SelectWrapperProps {
    onChange?: Function;
    accessor: string;
    disabled?: boolean;
    defaultValue?: any;
}

export const SearchDatePickerWrapper: React.FC<SelectWrapperProps> = (props: SelectWrapperProps) => {
    const location = useLocation();

    const {
        onChange,
        accessor,
        disabled = false,
        defaultValue = null
    } = props;

    const [values, setValues] = useState<string | null>(defaultValue);

    const handleChange = (value: string) => {
        setValues(value);

        // Format the date with time set to start of day (00:00:00)
        const formatted = moment(value).startOf('day').format("YYYY-MM-DD HH:mm:ss");

        if (onChange) {
            onChange(formatted);
        }
    };

    const queryParamsObject = useMemo(() => {
        if (location.search) {
            return queryParamsToObject(location.search);
        }
        return {};
    }, [location.search]);

    const formattedValue = useMemo(() => {
        if (queryParamsObject.hasOwnProperty(accessor)) {
            // @ts-ignore
            const rawDate = queryParamsObject[accessor];
            return moment(rawDate).format("YYYY-MM-DD");
        }
        return null;
    }, [queryParamsObject, accessor]);

    useEffect(() => {
        setValues(formattedValue);
    }, [formattedValue]);

    return (
        <input
            type="date"
            disabled={disabled}
            className={`bg-text-0 border border-surface-5 p-2 rounded-md w-full ${disabled ? "disable_date_picker" : values ? "text-surface-0" : "text-text-2"}`}
            onChange={(e:any) => handleChange(e.target.value)}
            value={values || ""}
            max={new Date().toISOString().split("T")[0]}
        />
    );
};
